import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpResponse } from '../models/http-response.model';
import { NewItemsCount } from '../models/new-items-count.model';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    private url = environment.url;

    constructor(private http: HttpClient) { }

    fetchDashboardNewItemsCount() {
        return this.http.get(this.url + 'profile/dashboard').pipe(
            map(v => NewItemsCount.adapt(v))
        );
    }

}